export default class LowSlide {
    constructor(slide) {
        this.slide = slide;
        this.rangeSlider = slide.querySelector('[data-range-slider]');
        this.rangeSlider = this.rangeSlider.querySelector('input');
        this.rangeSlider.addEventListener('input', this.updateMessage.bind(this));
        this.messages = slide.querySelectorAll('[data-message]');

        this.updateMessage();
    }

    updateMessage() {
        this.messages.forEach((message) => {
            message.classList.remove('is-active');
        });

        const value = this.rangeSlider.value;
        this.slide.querySelector(`[data-message="${value}"]`).classList.add('is-active');
    }

    setValue(value) {
        this.rangeSlider.value = value;
        this.rangeSlider.max = value;

        const event = new Event('input');
        this.rangeSlider.dispatchEvent(event);
    }
}